import {
  actionsSelector,
  cameraEnabledSelector,
  paramsSelector,
  useStore,
} from '@liveHelper/models/store'

import { useCheckCameraPermission } from '@core/devicePermissions/useCheckCameraPermission'
import { logMessage } from '@core/logging'
import { getGuestId } from '@core/tracking/guestId'

/**
 * A hook for accepting camera invite
 */
export const useAcceptCameraInvite = () => {
  const params = useStore(paramsSelector)
  const cameraEnabled = useStore(cameraEnabledSelector)
  const { acceptCameraInvite } = useStore(actionsSelector)

  const guestId = getGuestId()

  const { initiateCameraAccess } = useCheckCameraPermission({
    onAllowed: () => {
      acceptCameraInvite()
    },
    onRejected: () => {
      logMessage('camera permission rejected', {
        data: {
          visitor_id: guestId,
          chat_channel_id: params.chat_channel_id,
        },
      })
    },
    onDismissed: () => {
      logMessage('camera permission dismissed', {
        data: {
          visitor_id: guestId,
          chat_channel_id: params.chat_channel_id,
        },
      })
    },
  })

  const onAcceptCameraInvite = () => {
    if (!cameraEnabled) {
      initiateCameraAccess()
    }
  }

  return onAcceptCameraInvite
}
